(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uhs-mobile-nav-drawer"] && !Shopify.designMode) return;
  try {
    /*
  Self-contained open/close/back/drill-down behavior for every .uhs-mobile-nav
  panel on the page. No dependency on sections/uhs-header.liquid beyond a
  trigger button written as:
    <button type="button" data-mobile-nav-toggle aria-controls="[this panel's id]">
  (aria-controls is optional if there's only one panel on the page). See the
  markup above for how the panel's id is built (uhs-mobile-nav- + section id).

  Also exposes an imperative API for any other script to call directly:
    document.getElementById('uhs-mobile-nav-...').uhsMobileNav.open();
    document.getElementById('uhs-mobile-nav-...').uhsMobileNav.close();
  and dispatches 'uhs:mobile-nav:opened' / 'uhs:mobile-nav:closed' bubbling
  CustomEvents on the panel (e.g. so a cart drawer can close itself, or the
  hamburger button can toggle its own aria-expanded/icon state).
*/
(function () {
  'use strict';

  function initMobileNav(nav) {
    if (nav.dataset.uhsMnavInit) return;
    nav.dataset.uhsMnavInit = 'true';

    var closeBtn = nav.querySelector('[data-mobile-nav-close]');
    var backBtn = nav.querySelector('[data-back]');
    var viewport = nav.querySelector('.uhs-mobile-nav__viewport');
    var rootLevel = viewport ? viewport.querySelector('[data-level="root"]') : null;
    var triggerEl = null;

    function activeLevel() {
      return viewport.querySelector('.uhs-mobile-nav__level.is-active');
    }

    function showLevel(targetId) {
      var target = document.getElementById(targetId);
      if (!target) return;
      var current = activeLevel();
      if (current && current !== target) {
        current.classList.remove('is-active');
      }
      target.classList.add('is-active');
      var list = target.querySelector('.uhs-mobile-nav__list');
      if (list) list.scrollTop = 0;
      if (backBtn) {
        backBtn.hidden = target.dataset.level === 'root';
      }
    }

    function resetToRoot() {
      var current = activeLevel();
      if (current && rootLevel && current !== rootLevel) {
        current.classList.remove('is-active');
        rootLevel.classList.add('is-active');
      }
      if (backBtn) backBtn.hidden = true;
    }

    function open(trigger) {
      triggerEl = trigger || null;
      nav.hidden = false;
      requestAnimationFrame(function () {
        nav.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      nav.dispatchEvent(new CustomEvent('uhs:mobile-nav:opened', { bubbles: true }));
    }

    function close() {
      nav.classList.remove('is-open');
      nav.hidden = true;
      document.body.style.overflow = '';
      resetToRoot();
      if (triggerEl && typeof triggerEl.focus === 'function') {
        triggerEl.focus();
      }
      triggerEl = null;
      nav.dispatchEvent(new CustomEvent('uhs:mobile-nav:closed', { bubbles: true }));
    }

    nav.uhsMobileNav = { open: open, close: close };

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        var current = activeLevel();
        var parentId = current && current.dataset.parent;
        if (parentId) showLevel(parentId);
      });
    }

    if (viewport) {
      viewport.addEventListener('click', function (event) {
        var openBtn = event.target.closest('[data-open-level]');
        if (openBtn && viewport.contains(openBtn)) {
          showLevel(openBtn.dataset.openLevel);
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !nav.hidden) {
        close();
      }
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mobile-nav-toggle]');
      if (!trigger) return;
      var controls = trigger.getAttribute('aria-controls');
      if (controls && controls !== nav.id) return;
      if (!controls && document.querySelectorAll('.uhs-mobile-nav').length > 1) return;
      event.preventDefault();
      open(trigger);
    });
  }

  document.querySelectorAll('.uhs-mobile-nav').forEach(initMobileNav);
})();
  } catch(e) { console.error(e); }
})();

})();
